<template>
    <div>
        <div v-if="mode === 'edit'">
            <span style="font-weight: bold;">系统上传要求：</span>单图分辨率800*800px，最大不得超过2M｜仅支持JPG、JPEG格式
        </div>

        <div>
            <div
                v-if="mode === 'edit' || value.length"
                style="display: flex; align-items: top;"
            >
                <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                <DragFileUpload
                    v-for="(rulesItem, rulesIndex) in getPicRule.picRule"
                    ref="dragfileupload"
                    :key="rulesIndex"
                    :disabled="isDisabled"
                    :value="getImageValue(rulesIndex)"
                    :show-only="isShowOnly"
                    :desc="rulesItem"
                    style="width:150px"
                    v-bind="uploadProps"
                    :need-border="rulesIndex === 0"
                    :validate-rule="validateRule"
                    @input="(arr) => skuPictureListInput(arr, rulesIndex)"
                    @change="(imageObj) => skuPictureChange(imageObj, rulesIndex)"
                >
                    <template
                        :slot="`${(value && value[rulesIndex] && value[rulesIndex])|| ''}`"
                    >
                        <!-- 图片质量信息 -->
                        <div
                            v-if="
                                !isShowOnly && !isDisabled && imageInfoList[rulesIndex]
                                && rulesIndex === imageInfoList[rulesIndex].sequence
                            "
                            class="img-quality-info"
                            >
                            <div
                                v-if="imageInfoList[rulesIndex].totalScore && imageInfoList[rulesIndex].totalScore !== -1"
                                class="img-quality-info-score"
                                :style="{color: imageInfoList[rulesIndex].isQualify ? 'green' : 'red' }"
                            >
                                {{ `图片质量分: ${imageInfoList[rulesIndex].totalScore}分` }}
                            </div>
                            <div
                                v-if="!imageInfoList[rulesIndex].isQualify && imageInfoList[rulesIndex].reason"
                            >
                                <mc-tooltip
                                    :content="imageInfoList[rulesIndex].reason"
                                    placement="top"
                                    theme="light"
                                >
                                    <div class="img-quality-info-reason">
                                        {{ imageInfoList[rulesIndex].reason }}
                                    </div>
                                </mc-tooltip>
                            </div>
                        </div>
                    </template>
                </DragFileUpload>
            </div>
            <span v-else>无</span>
        </div>

        <!-- 【新增】根据 showExampleAndRequirement 属性控制显示 -->
        <div v-if="showExampleAndRequirement" class="example-list">
            <mc-link
                style="color: #999"
                @click="isShowExample = !isShowExample"
            >
                {{ isShowExample ? '关闭示例' : '查看示例' }}
            </mc-link>

            <mc-link path="https://p0.meituan.net/mallimages/1290b076c36b9b0cfc13be365272fce9976419.jpg">
                查看审核要求
            </mc-link>
        </div>

        <!-- 【新增】根据 showExampleAndRequirement 属性控制显示 -->
        <transition v-if="showExampleAndRequirement" name="example-image">
            <div v-if="isShowExample">
                <div
                    v-for="(urlItem, urlIndex) in getPicRule.exampleImgUrlList"
                    :key="urlIndex"
                    class="image-list"
                >
                    <mc-image
                        class="pic-image"
                        :src="urlItem"
                        :preview-url-list="getPicRule.exampleImgUrlList"
                        :preview-first-index="urlIndex"
                    />

                    <div style="text-align: center; color: #999; margin-top: -10px">
                        {{ getPicRule.picRule && getPicRule.picRule[urlIndex] }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
/* eslint-disable import/no-unresolved */
import { computed, getCurrentInstance, ref, watch } from '@vue/composition-api';
import DragFileUpload from 'components/DragFileUpload';
import judgeAttrUnderReview from 'utils/spAttrsApprove';
import MixinJudgeRejectedAttrsDisabled from './createNewProduct/mixins/rejectedDisabled';

export default {
    components: {
        DragFileUpload,
    },
    mixins: [MixinJudgeRejectedAttrsDisabled],
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        // 状态
        mode: {
            type: String,
            default: '',
        },
        // 审核字段
        modifiyAttrs: {
            type: Array,
            default: () => ([]),
        },
        judgeAttrDisabled: {
            type: Boolean,
            default: true,
        },
        // 校验规则
        validateRule: {
            type: Object,
            default: () => ({}),
        },
        // 图片规则
        picRule: {
            type: Object,
            default: () => ({}),
        },
        // SKU信息
        skuInfo: {
            type: Object,
            default: () => ({}),
        },
        // 商品主图 AI 打分列表
        picAiScoreList: {
            type: Object,
            default: () => ({}),
        },
        // 【新增】是否显示示例和查看审核要求
        showExampleAndRequirement: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance();

        // 配置项
        const uploadProps = Object.freeze({
            style: 'width:150px',
            maxPic: 1,
            rowCount: 1,
            margin: 5,
            isValidate: true,
            dgWaterMark: true,
        });

        const isShowExample = ref(true);
        const imageInfoList = ref(props.picAiScoreList); // 存储图片ai打分列表信息
        watch(() => props.picAiScoreList, (newVal) => {
            imageInfoList.value = newVal;
        }, { immediate: true });

        // 是否禁用
        const isDisabled = computed(() => judgeAttrUnderReview(props.modifiyAttrs, 'skuMainPictureList') || props.judgeAttrDisabled) || proxy.MixinJudgeRejectedAttrsDisabled('skuPictureList');
        const isShowOnly = computed(() => props.mode === 'show' || judgeAttrUnderReview(props.modifiyAttrs, 'skuMainPictureList'));

        // value值
        const getImageValue = computed(() => (rulesIndex) => {
            const url = props.value?.[rulesIndex];
            return url ? [url] : [];
        });

        const skuPictureListInput = (urlList, rulesIndex) => {
            const pictureList = [...props.value];
            pictureList[rulesIndex] = urlList?.[0] || '';
            proxy.$emit('input', pictureList);
        };

        // 获取图片信息的方法, 参数传url, index
        const getImageInfo = async (index, url) => {
            if (!url) return;
            // 切换主图后，对应图的 AI 识别信息打分都置为 -1, 表示无效分数，提交检验的时候进行分数卡控
            imageInfoList.value = {
                ...imageInfoList.value,
                [index]: {
                    sequence: index,
                    picUrl: url,
                    isTextImage: false,
                    reason: '',
                    totalScore: -1,
                    isQualify: 0,
                },
            };
            let pollCount = 0;
            const fetchScore = async () => {
                try {
                    const params = {
                        skuName: props.skuInfo.skuName,
                        picUrl: url,
                        sequence: index,
                        isRequestAIWhenNotExist: true,
                    };
                    const res = await proxy.$hPost('/api/vss/shepherd/product/bizcenter/productAlgToolTService/getPictureScoreByAI', params);
                    // 检查AI评分进度，只有进度为 100 的时候才更新信息
                    if (res && res.aiScoreProgress === 100) {
                        // 分数在 0 ~ 100 才会为有效分数
                        const totalScore = (+res.totalScore > 0 && +res.totalScore <= 100) ? +res.totalScore : -1;
                        imageInfoList.value = {
                            ...imageInfoList.value,
                            [index]: {
                                sequence: index,
                                picUrl: url,
                                isTextImage: res.isTextImage,
                                reason: res.reason,
                                totalScore,
                                isQualify: totalScore > 70 ? 1 : 0,
                            },
                        };
                        return true;
                    }
                    pollCount += 1;
                    // 最大请求25次，超过25次记为异常
                    if (pollCount >= 25) {
                        imageInfoList.value = {
                            ...imageInfoList.value,
                            [index]: {
                                sequence: index,
                                picUrl: url,
                                isTextImage: false,
                                reason: '',
                                totalScore: -1,
                                isQualify: 0,
                            },
                        };
                        proxy.$message.error(`第 ${index + 1} 张主图获取AI评分失败，请重新上传图片重试`);
                        return true;
                    }
                    return false;
                } catch (e) {
                    proxy.$message.error(`第 ${index + 1} 张主图获取AI评分失败，请重新上传图片重试`);
                    return true;
                }
            };
            const poll = async () => {
                const success = await fetchScore();
                if (!success) {
                    setTimeout(poll, 2000);
                }
            };
            await poll();
        };

        const skuPictureChange = (imageObj, rulesIndex) => {
            proxy.$emit('change', imageObj, rulesIndex);
            // 获取图片AI打分信息, 这里第一张图需要进行算法识别，需要取最终结果，外侧走单独调用打分
            if (rulesIndex !== 0 && imageObj?.url) {
                getImageInfo(rulesIndex, imageObj.url);
            }
        };

        const getPicRule = computed(() => {
            const { exampleImgUrlList, ...items } = props.picRule || {};
            const descriptionsArray = Object.values(items).length ? Object.values(items) : new Array(6).fill('');
            return {
                exampleImgUrlList,
                picRule: descriptionsArray,
            };
        });

        const initImgArray = (index, urlArr) => {
            const pictureList = [...props.value];
            pictureList[index] = urlArr[0];
            if (proxy.$refs?.dragfileupload?.[index]) proxy.$refs.dragfileupload[index].initImgArray(urlArr);
            if (!urlArr[0])proxy.$refs.dragfileupload[index].removeImage();
        };

        return {
            judgeAttrUnderReview,
            uploadProps,
            isShowExample,
            getPicRule,
            isDisabled,
            isShowOnly,
            getImageValue,
            skuPictureListInput,
            skuPictureChange,
            initImgArray,
            imageInfoList,
            getImageInfo,
        };
    },
};
</script>

<style lang="scss" scoped>
.image-list {
    display: inline-block;
    margin-right: 20px;
}

.img-quality-info {
    font-size: 12px;
    text-align: center;
    width: 130px;
    .img-quality-info-score {
        line-height: 20px;
    }
    .img-quality-info-reason {
        line-height: 20px;
        background: red;
        color: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 5px;
    }
}

.pic-image {
    width: 130px;
    height: 130px;
    padding: 5px;
    border: 1px solid #e0e0e0;
    border-radius: 3;
}

.example-list {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.example-image-enter-active, .example-image-leave-active {
    transition: all 0.5s ease;
}

.example-image-enter, .example-image-leave-to /* .slide-leave-active in <2.1.8 */ {
    transform: translateY(-20px);
    opacity: 0;
}

.mc-button {
    &.ml-400 {
        margin-left: 380px;
    }

    &.rotate-90,
    &.rotate--90 {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
    }

    &.rotate-90 {
        transform: rotate(90deg);
    }

    &.rotate--90 {
        transform: rotate(-90deg);
    }

    ::v-deep .mtdicon-fast-backward {
        font-size: 25px;
    }
}
.wrapper {
    border: none;
    ::v-deep {
        .img-area,
        .add-img {
            width: 130px !important;
            height: 130px !important;
            margin: 0 !important;
        }
    }
}

</style>
